<template>
    <div class="d-flex align-items-center" v-if="!params.node.rowPinned">
        <b-button
            v-if="reservationEdit && params.data.status != 'BLOCKED'"
            variant="default"
            class="mr-2"
            :href="editReservationLink"
            ><font-awesome-icon :icon="['fas', 'pen-to-square']"
        /></b-button>
        <b-button
            v-if="reservationDelete && params.data.booking_method != 'AIRBNB' && params.data.status != 'BLOCKED'"
            variant="default"
            @click="$bvModal.show(modalId)"
            ><font-awesome-icon :icon="['fas', 'trash']"
        /></b-button>
        <modal
            :id="deletionConfirmationModalId"
            title="Deletion confirmation"
            ok-title="Proceed"
            cancel-title="Close"
            @ok="deleteReservation"
        >
            Warning! VRBO now assesses cancellation fees for all partner / host initiated cancellations. To avoid these
            fees all VRBO reservations need to be canceled by the guest. To learn more about VRBO's partner initiated
            cancellation fees, please visit:
            <a href="https://help.vrbo.com/articles/Partner-Cancellation-Fee-Policy" target="_blank">
                https://help.vrbo.com/articles/Partner-Cancellation-Fee-Policy
            </a>
        </modal>
        <validation-observer v-slot="{ meta }" validateOnMount>
            <modal
                :id="modalId"
                title="Delete Reservation"
                ok-title="Delete"
                @ok.prevent="
                    () =>
                        params.data.booking_method === 'HOMEAWAY' && params.data.status !== 'CANCELLED'
                            ? $bvModal.show(deletionConfirmationModalId)
                            : deleteReservation()
                "
                :ok-disabled="!meta.valid"
            >
                <validation-provider name="password" rules="required" v-slot="{ errors, handleChange }">
                    <form-input
                        type="password"
                        v-model="password"
                        label="Please enter your system password to confirm reservation deletion"
                        :error="errors[0]"
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
            </modal>
        </validation-observer>
    </div>
</template>

<script>
    import FormInput from '../../generic/form-input/form-input.vue';
    import Modal from '../../generic/modal/modal.vue';
    import { mapGetters } from 'vuex';
    import responsiveButton from '../../generic/responsive-button/responsive-button.vue';
    export default {
        components: { responsiveButton, Modal, FormInput },
        data() {
            return {
                modalId: null,
                deletionConfirmationModalId: null,
                password: null,
            };
        },
        mounted() {
            this.modalId = 'modalId' + this.params.data.id;
            this.deletionConfirmationModalId = 'deletion-confirmation-modalId' + this.params.data.id;
        },
        computed: {
            ...mapGetters('reservationsStore', ['reservationDelete', 'reservationEdit']),
            editReservationLink() {
                return `/app/guest/${this.params.data.user_id}/invoices/?reservation=${this.params.data.id}`;
            },
        },
        methods: {
            deleteReservation() {
                if (this.params.deleteReservation) {
                    this.params.deleteReservation(this.password, this.params.data.id);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .reservation-status-marker {
        border-radius: 50%;
        width: 20px;
        height: 20px;
    }
</style>
